export const BRAND = {
  name: "Braiding Elevation Inc",
  slogan: "We complete for excellency",
  phone: "301-455-0210",
  phoneHref: "tel:+13014550210",
  address: "6490 Landover Rd Suite B3",
  hours: "Open 7 Days a Week",
  instagram: "https://instagram.com/gallethebraider",
  tiktok: "https://tiktok.com/@gallethebraider",
  handle: "@gallethebraider",
};

export const IMAGES = {
  logo: "https://customer-assets-lxgj4vgw.emergentagent.net/job_271da9eb-3da9-44cd-bcac-305df726039b/artifacts/7xu957of_logo-png.webp",
  g1: "https://customer-assets-lxgj4vgw.emergentagent.net/job_271da9eb-3da9-44cd-bcac-305df726039b/artifacts/31dq6hlz_IMG-20250911-WA0059.jpg",
  g2: "https://customer-assets-lxgj4vgw.emergentagent.net/job_271da9eb-3da9-44cd-bcac-305df726039b/artifacts/o7742a95_IMG-20250911-WA0058.jpg",
  g3: "https://customer-assets-lxgj4vgw.emergentagent.net/job_271da9eb-3da9-44cd-bcac-305df726039b/artifacts/f9p8fhui_IMG-20250911-WA0020.jpg",
  g4: "https://customer-assets-lxgj4vgw.emergentagent.net/job_271da9eb-3da9-44cd-bcac-305df726039b/artifacts/nhawwkbb_IMG-20250911-WA0017.jpg",
};

export const SERVICES = [
  {
    n: "01",
    title: "Box Braids",
    desc: "Timeless, protective, endlessly versatile. Knotless or traditional, sized and lengthened exactly to you.",
    img: IMAGES.g3,
  },
  {
    n: "02",
    title: "Rope Twists",
    desc: "Sculpted two-strand twists with a flawless finish — bold texture that turns every head in the room.",
    img: IMAGES.g1,
  },
  {
    n: "03",
    title: "Boho & Curly Ends",
    desc: "Braids meet soft, cascading curls. A romantic, editorial silhouette engineered for movement.",
    img: IMAGES.g2,
  },
  {
    n: "04",
    title: "Honey Twists",
    desc: "Warm, dimensional color woven through crisp twists — luminous from root to curl.",
    img: IMAGES.g4,
  },
  {
    n: "05",
    title: "Cornrows & Feed-ins",
    desc: "Precision parting and clean, straight-back lines. The foundation of every elevated style.",
    img: IMAGES.g1,
  },
  {
    n: "06",
    title: "Kids Braiding",
    desc: "Gentle, patient, and comfortable styling for little ones — protective looks that last for weeks.",
    img: IMAGES.g3,
  },
];

export const SERVICE_OPTIONS = [
  "Box Braids",
  "Rope Twists",
  "Boho / Curly Ends",
  "Honey Twists",
  "Cornrows & Feed-ins",
  "Knotless Braids",
  "Kids Braiding",
  "Other / Not sure yet",
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Precision as a standard",
    body: "Every part is measured, every braid tensioned with intent. We don't chase trends — we perfect the craft behind them.",
  },
  {
    n: "02",
    title: "Protective by design",
    body: "Healthy hair is the goal beneath the beauty. Our techniques protect your edges and your length while you shine.",
  },
  {
    n: "03",
    title: "Built for your crown",
    body: "No two heads are alike. We tailor length, size, color and finish to your face, your lifestyle, your story.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "The neatest twists I have ever had. Six weeks in and they still look freshly done. Truly competing for excellency.",
    name: "Tanya M.",
    role: "Rope Twists",
  },
  {
    quote:
      "Gentle hands, immaculate parting, and the boho curls were everything. I drove an hour and would do it again.",
    name: "Denise R.",
    role: "Boho Knotless",
  },
  {
    quote:
      "Booked my daughter and myself. Comfortable, on time, and the finish was flawless. This is our salon now.",
    name: "Karlene P.",
    role: "Box Braids + Kids",
  },
];
